const TFoodScreen = {
    // English
    "enUS": {
        'FOOD': 'Food',
        'ADD_FOOD': 'Add Food',
        'NEW_FOOD': 'Food',
        'FOOD_NAME': 'Food name',
        'IMAGE': 'Image',
        'NAME': 'Name',
        'PRICE': 'Prices',
        'DESC': 'Description',
        'SAVE': 'Save',
        'CANCEL': 'Cancel',
        'LOAD_MORE': 'Load More',
        'ACTIVE': 'Active',
        'INACTIVE': 'Inactive',
        'SHOW': 'Show',
        'SEARCH': 'Search',
    },
    // Spanish
    "esMX": {
        'FOOD': 'Alimentos',
        'ADD_FOOD': 'Agregar Alimento',
        'NEW_FOOD': 'Nuevo alimento',
        'FOOD_NAME': 'Nombre de alimento',
        'IMAGE': 'Imagen',
        'NAME': 'Nombre',
        'PRICE': 'Precios',
        'DESC': 'Descripción',
        'SAVE': 'Guardar',
        'CANCEL': 'Cancelar',
        'LOAD_MORE': 'Cargar Más',
        'ACTIVE': 'Activos',
        'INACTIVE': 'Inactivos',
        'SHOW': 'Mostrar',
        'SEARCH': 'Buscar',
    }
}
export default TFoodScreen;